import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { renderAsync } from 'docx-preview';

@Component({
  selector: 'app-word-file-handler',
  templateUrl: './word-file-handler.component.html',
  styleUrl: './word-file-handler.component.scss',
})
export class WordFileHandlerComponent implements OnInit {
  @Input() docxUrl!: string;
  @ViewChild('docxContainer', { static: true })
  docxContainer!: ElementRef<HTMLDivElement>;

  async ngOnInit() {
    const response = await fetch(this.docxUrl);
    const blob = await response.blob();
    const arrayBuffer = await blob.arrayBuffer();

    renderAsync(arrayBuffer, this.docxContainer.nativeElement, undefined, {
      inWrapper: true,
      ignoreWidth: false,
      ignoreHeight: false,
      ignoreFonts: false,
      breakPages: true,
    });
  }
}
